import { render, staticRenderFns } from "./remote-editor.vue?vue&type=template&id=83c35cae&scoped=true&"
import script from "./remote-editor.vue?vue&type=script&lang=js&"
export * from "./remote-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c35cae",
  null
  
)

export default component.exports